import { Control, FieldValues, Path } from "react-hook-form";

import { SignalPreviewCountsByKey } from "lib/hooks/api/signals/useSignalPreviewCounts";
import ClearAllSignalButton from "../ClearAllSignalButton";
import SimpleSupplierSelect from "./simple_supplier_select/SimpleSupplierSelect";
import { SupplierInputExplanation } from "./SupplierInputExplanation";

import css from "./SupplierInput.module.scss";

type SupplierInputProps<T extends FieldValues> = {
  competitorFieldName: Path<T>;
  partnerFieldName: Path<T>;
  control: Control<T, unknown>;
  competitorCounts: SignalPreviewCountsByKey | undefined;
  partnerCounts: SignalPreviewCountsByKey | undefined;
  isLoadingCounts?: boolean;
};

export default function SupplierInput<T extends FieldValues>({
  competitorFieldName,
  partnerFieldName,
  control,
  competitorCounts,
  partnerCounts,
  isLoadingCounts = false,
}: SupplierInputProps<T>) {
  return (
    <div className={css.container}>
      <div className={css.section}>
        <div className={css.header}>
          <p className={css.title}>Competitors</p>
          <SupplierInputExplanation supplierType="competitor" />
        </div>
        <SimpleSupplierSelect
          mode="multiple"
          name={competitorFieldName}
          control={control}
          label=""
          counts={competitorCounts}
          isLoadingCounts={isLoadingCounts}
          tagVariant="error"
          placeholder="Search for competitors"
        />
      </div>
      <ClearAllSignalButton name={competitorFieldName} control={control} />
      <div className={css.section}>
        <div className={css.header}>
          <p className={css.title}>Partners</p>
          <SupplierInputExplanation supplierType="partner" />
        </div>
        <SimpleSupplierSelect
          mode="multiple"
          name={partnerFieldName}
          control={control}
          label=""
          counts={partnerCounts}
          isLoadingCounts={isLoadingCounts}
          tagVariant="warning"
          placeholder="Search for partners"
        />
      </div>
      <ClearAllSignalButton name={partnerFieldName} control={control} />
    </div>
  );
}
